import { TaggedUrl } from './../../../web';
import { Interceptor, InterceptorRequestConfig } from '../http.service';

export function tagUrl(): Interceptor {
    return {
        request: (config: InterceptorRequestConfig) => {
            config.taggedUrl = new TaggedUrl(config.url ?? '');
            config.url = config.taggedUrl.url;
        }
    };
}
